// extracted by mini-css-extract-plugin
module.exports = {"gameArea":"Game_gameArea__3p9uv","playerScore":"Game_playerScore__1xL8G","scoreElement":"Game_scoreElement__1wBTE"};